export default function useJsonStorage(key) {
  const clear = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key)
    }
  }

  const get = () => {
    if (typeof window !== 'undefined') {
      const jsonStr = localStorage.getItem(key)
      if (jsonStr != null) {
        try {
          return JSON.parse(jsonStr)
        } catch (err) {
          return null
        }
      } else {
        return jsonStr
      }
    }
  }

  const set = (value) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(value))
    }
  }

  return [get, set, clear]
}
